import { getBrowserInfo } from './browser';

export const generateBugReportTemplate = (message?: string) => `**Error Details:**
${message || ''}

**Screenshots/Videos:**
- If applicable, add screenshots or video links to help explain the problem

**Steps to Reproduce:**
1.  List each step needed to reproduce the error
2.  Be as specific as possible
3.  Include any relevant settings or conditions

**Expected Behavior:**
- Describe what should have happened when following the steps above

**Actual Behavior:**
- Describe what actually happened instead
- Include any error messages or unexpected behavior

**Additional Context:**
- Prior Actions: // What were you doing before the error occurred?
- Frequency: // How often does this occur? (Always, Sometimes, First time)
- Impact: // How does this affect your work?

---
Generated: ${new Date().toISOString()}
`;

export const generateFeatureRequestTemplate = (message?: string) => `**Feature Description:**
${message || ''}

**Motivation:**
- Why do you want this feature? How would it benefit/impact you or others?

**Proposed Solution(s):**
- If you have any specific ideas about how this feature could be implemented, describe them here

**Additional Context:**
- Add any other context, screenshots, or examples about the feature request here    

---
Generated: ${new Date().toISOString()}
`;

export function genTemplateGitHub({
  type,
  framework,
}: {
  type: 'bug' | 'feature';
  framework: string | undefined;
}): string {
  const browserInfo = getBrowserInfo();
  const enhancedBody = `${type === 'bug' ? generateBugReportTemplate() : generateFeatureRequestTemplate()}\n\n ${framework ? '## Framework: ' + framework + '\n' : ''}
## System Information\n\`\`\`json\n${JSON.stringify({ browserInfo }, null, 2)}\n\`\`\`\n`;
  return enhancedBody;
}
